import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CenterInitiatedRepatriationCreateFormDialog from './CenterInitiatedRepatriationCreateFormDialog';

class CenterInitiatedRepatriationCreateForm extends Component {
  render() {
    return (
      <div>
        <CenterInitiatedRepatriationCreateFormDialog
          data={this.props.data}
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
        />
      </div>
    );
  }
}

CenterInitiatedRepatriationCreateForm.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  data: PropTypes.shape({
    inbound: PropTypes.string,
    outbound: PropTypes.string,
  }).isRequired,
};

export default CenterInitiatedRepatriationCreateForm;
